import {useState, useEffect} from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';

const Sms = () => {

    const { readData } = useEntityCrud('Config/get');
    const { addData } = useEntityCrud('Config/update');
    const [message,setMessage] = useState('');

    useEffect(() => {
        readData({key: 'smsContent'}).then(({data}) => {
            if(data.status)
                setMessage(data.result.value);
        })
    },[])

    const updateMessage = () => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            key: 'smsContent',
            value: message
        };
        addData(postedData).then(({data}) => {
            if(data.status)
                toast.success('متن پیامک با موفقیت به روزرسانی شد');
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">به روزرسانی متن پیامک نظرسنجی</div>
            </div>
            <div className="card-body">
                <div className="form-group">
                    <label>متن پیامک</label>
                    <input className="form-control py-4" value={message} onChange={e => setMessage(e.target.value)} />
                </div>
                <button id="btn-submit-form" className="btn btn-success" onClick={updateMessage}>به روزرسانی</button>
            </div>
        </div>
    );
}

export default Sms;